(() => {
  angular
    .module('app.report')
    .controller('OverviewReportController', OverviewReport);

  OverviewReport.$inject = [
    '$scope',
    '$filter',
    '$window',
    '$cookies',
    '$timeout',
    'Report',
    'ChartService'
  ];

  function OverviewReport(
    $scope,
    $filter,
    $window,
    $cookies,
    $timeout,
    Report,
    ChartService
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    let isVisibilityWatcherSet = false;
    let cache = {
      overviewData: null,
      chart: {
        options: ChartService.getBaseChartConfig(),
        data: null,
      },
    };

    const { report } = $scope.$parent;
    const vm = this;
    vm.showTQWarning = true;
    vm.campaignCountry = undefined;
    vm.totalEvents = 0;
    vm.percentOutsideTargetCountry = 0;
    vm.totalImpBuildupChartConfig = {
        series: [{
        color: cache.chart.options.colors[0],
        name: 'Events',
        data: 0,
      }, {
        color: cache.chart.options.colors[1],
        name: 'In target group',
        data: 0,
      }]
    };

    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      if (angular.isUndefined($cookies.getObject('showTQWarning'))) {
        const campaignId = parseInt($window.location.pathname.split('/')[2]);
        $cookies.putObject('showTQWarning', true, {
          path: `/report/${campaignId}`
        });
      } else {
        vm.showTQWarning = $cookies.getObject('showTQWarning');
      }

      Report.getOverviewData(report.campaignIdParam).$promise
        .then(({ data }) => {
          cache.overviewData = data;

          vm.overviewDataLoaded = true;

          report.isCampaignLoading = false;
          report.isCampaignLoaded = true;

          if (document.visibilityState === 'visible') {
            updateDataOnVisible();
          } else {
            if (!isVisibilityWatcherSet) {
              document.addEventListener('visibilitychange', updateDataOnVisible);
              isVisibilityWatcherSet = true;
            }
          }
        });

      /* ------------------------------
       Logic for displaying the Delivery warning for impressions outside target country
       --------------------------------*/
      report.campaignPromise.then(campaign => {
        if (campaign) {
          vm.campaignCountry = campaign.panel_country;

          const param = {'id': campaign.pid};
          Report.getDelivery(param).$promise
            .then(tqResponse => {
              if (angular.isDefined(tqResponse)) {
                vm.totalEvents = angular.isDefined(tqResponse.data) ?
                  tqResponse.data.totalCount : undefined;

                const topLookupCountries = angular.isDefined(tqResponse.data) ?
                  tqResponse.data.lookupCountries : undefined;

                angular.forEach(topLookupCountries, lookupCountry => {
                  if (lookupCountry.countryCode === vm.campaignCountry) {
                    vm.percentOutsideTargetCountry = 100 - lookupCountry.count * 100 / vm.totalEvents;
                  }
                });
              }
            });
        }
      });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      updateOverviewSection();
      updateTotalEventBuildupChart();
      updateEventDetailsTable();
    }

    function updateOverviewSection() {
      if (!cache.overviewData) {
        return false;
      }

      vm.overviewData = cache.overviewData;

      const { totals } = vm.overviewData;
      if (totals) {
        vm.countryEvents = (typeof totals.countryEvents === 'number') && totals.countryEvents;
        vm.reachRadius = getComputedRadius(totals.reach);
      }
    }

    function getComputedRadius(value = 0) {
      const R = 100; // Radius in pixels
      const S = Math.PI * Math.pow(R, 2);
      const SReach = (value * S) / 100;
      return Math.sqrt(SReach / Math.PI);
    }

    function updateEventDetailsTable() {
      if (!cache.overviewData) {
        return false;
      }

      const impDetails = cache.overviewData;

      if (vm.impDetails && impDetails && impDetails.reportItems) {
        const allImpDetails = [
          ...impDetails.reportItems,
          impDetails.totals,
        ];

        if (vm.impDetails.reportItems) {
          allImpDetails.forEach(item => {
            const row = [
              ...vm.impDetails.reportItems,
              vm.impDetails.totals,
            ].find(curr => (
              (curr.tailcode && (curr.tailcode === item.tailcode)) ||
              (curr.fusionId && (curr.fusionId === item.fusionId)) ||
              (curr.name === 'Total')
            ));

            // update existing rows for splash animation
            if (row) {
              row.events = item.events;
              row.targetEvents = item.targetEvents;
            }
          });
        }

        // delay for odometer splash animation
        $timeout(() => {
          vm.impDetails = impDetails;
        }, TIME.DATA_SPLASH);
      } else {
        vm.impDetails = impDetails;
      }

        // invalidate table after splash animation finished
      $timeout(() => {
        const dtTable = $('#tableEventDetails').DataTable();
        dtTable.cells().invalidate('dom').draw();
      }, TIME.DATA_SPLASH);
    }

    function updateTotalEventBuildupChart() {
      if (!cache.overviewData) {
        return false;
      }

      vm.impWeekly = cache.overviewData.weekly;
      vm.weekLabels = _.pluck(_.values(vm.impWeekly), 'week');

      vm.totalImpBuildupChartConfig.options = getCustomChartOptions();

      if (angular.isDefined(vm.impWeekly) && vm.impWeekly.length !== 0) {
        const series = [
          _.pluck(_.values(vm.impWeekly), 'events'),
          _.pluck(_.values(vm.impWeekly), 'targetEvents'),
        ];

        if (!cache.chart.data || isChartDirty(series)) {
          for (let i = 0; i < series.length; i++) {
            vm.totalImpBuildupChartConfig.series[i].data = series[i];
          }
          cache.chart.data = series;
        }
      } else {
        vm.totalImpBuildupChartConfig.loading = 'No data.';
      }
    }

    function isChartDirty(series) {
      let updated = false;
      for (let i = 0; i < series.length; i++) {
        updated = !_.isEmpty(_.difference(cache.chart.data[i], series[i]));
        if (updated) {
          return updated;
        }
      }
      return updated;
    }

    function getCustomChartOptions() {
      return angular.merge(cache.chart.options, {
        tooltip: {
          formatter: function () {
            function row(color, name, val) {
              return `
                <tr>
                  <td class="td-left">
                    <span class="bullet bullet-small" style="background-color:${color};"></span>
                    ${name}:
                  </td>
                  <td class="td-right">${val.toLocaleString()}</td>
                </tr>`;
            }

            function rows(points) {
              return points.reduce((rows, point) => {
                const {color, name} = point.series;
                return `${rows} ${row(color, name, point.y)}`;
              }, '');
            }

            function getMargin(week) {
              const margin = _.pluck(vm.impWeekly, 'marginal');
              return margin[week];
            }

            return `
              <h4>week ${vm.weekLabels[this.x]}</h4>
              <div class="highcharts-tooltip-outer">
                <table class="highcharts-tooltip-inner">
                  ${rows(this.points)}
                  ${row('', 'Weekly increase', getMargin(this.x))}
                </table>
              </div>`;
          }
        },
        xAxis: {
          labels: {
            formatter: function () {
              return `Week ${vm.weekLabels[this.value]}`;
            }
          }
        },
      });
    }

    vm.getSampleSizeErrorLevel = reportItem => reportItem.nStatus;
    vm.getSampleSizeErrorTooltip = reportItem => {
      switch (vm.getSampleSizeErrorLevel(reportItem)) {
        case 'warning': return `Sample size is ${reportItem.n}. That seems a bit low!`;
        case 'error': return 'No sample size - please check the implementation!';
        default: return `Sample size is ${$filter('number')(reportItem.n)}`;
      }
    };

    vm.disableWarningForSession = function () {
      const campaignId = parseInt($window.location.pathname.split('/')[2]);
      vm.showTQWarning = false;
      $cookies.putObject('showTQWarning', false, {
        path: `/report/${campaignId}`
      });
    };

    vm.getReportItem = ri => report.campaign.reportItems.find(item => item.evid === ri.evid);
    vm.isTVEnabled = reportItem => {
      const ri = vm.getReportItem(reportItem);
      return ri && ri.properties.featureTVEnabled === 1;
    };

    vm.isStandard = () => report.campaign && report.campaign.type === 'standard';
    vm.getProvider = provider => report.getProvider(provider);
  }
})();
